// extracted by mini-css-extract-plugin
export var centerText = "_6s-8";
export var container = "_6s-0";
export var doughnutContainer = "_6s-7";
export var legend = "_6s-a";
export var legendItemColorDisplay = "_6s-b";
export var legendItemLabel = "_6s-d";
export var legendItemValue = "_6s-c";
export var lg = "_6s-5";
export var maxWidth = "_6s-9";
export var md = "_6s-4";
export var responsive = "_6s-6";
export var sm = "_6s-3";
export var xs = "_6s-2";
export var xxs = "_6s-1";